import moment from "moment";

export const ACTION_TYPES = {
    LOGIN_SUCCESS: "login_success",
    LOGOUT_SUCCESS: "logout_success",
    GET_CONFIGS: "get_configs",
    SET_CONFIGS: "set_configs",
    GET_DISPATCHING_DATA: "get_dispatching_data",
};

export const SUPPLIER_STATUSES = {
    ASSIGNED: {
        statusId: 0,
        name: "_assigned_",
        className: "warning",
    },
    ACCEPTED: {
        statusId: 1,
        name: "_accepted_",
        className: "success",
    },
    CONFIGURED: {
        statusId: 2,
        name: "_configured_",
        className: "success",
    },
    ON_WAY: {
        statusId: 3,
        name: "_on_way_",
        className: "info",
    },
    PICKED_UP: {
        statusId: 4,
        name: "_picked_up_",
        className: "info",
    },
    DELIVERED: {
        statusId: 5,
        name: "_delivered_",
        className: "danger",
    },
    VERIFIED: {
        statusId: 6,
        name: "_verified_",
        className: "danger",
    },
    AT_SUPPLIER: {
        statusId: 7,
        name: "_at_supplier_",
        className: "danger",
    },
    statusById(id) {
        switch (id) {
            case SUPPLIER_STATUSES.ACCEPTED.statusId:
                return SUPPLIER_STATUSES.ACCEPTED;
            case SUPPLIER_STATUSES.CONFIGURED.statusId:
                return SUPPLIER_STATUSES.CONFIGURED;
            case SUPPLIER_STATUSES.ON_WAY.statusId:
                return SUPPLIER_STATUSES.ON_WAY;
            case SUPPLIER_STATUSES.PICKED_UP.statusId:
                return SUPPLIER_STATUSES.PICKED_UP;
            case SUPPLIER_STATUSES.DELIVERED.statusId:
                return SUPPLIER_STATUSES.DELIVERED;
            case SUPPLIER_STATUSES.VERIFIED.statusId:
                return SUPPLIER_STATUSES.VERIFIED;
            case SUPPLIER_STATUSES.AT_SUPPLIER.statusId:
                return SUPPLIER_STATUSES.AT_SUPPLIER;
            case SUPPLIER_STATUSES.ASSIGNED.statusId:
            default:
                return SUPPLIER_STATUSES.ASSIGNED;
        }
    },
};

export const GEOCODER_SUCCESS = "OK";

export const ORDER_TYPES_ENUM = {
    STANDARD: "STANDARD",
    PRE_ORDER: "PRE_ORDER",
};

export const ORDER_TYPES = [
    {
        label: "Ստանդարտ",
        value: ORDER_TYPES_ENUM.STANDARD,
    },
    {
        label: "Նախնական",
        value: ORDER_TYPES_ENUM.PRE_ORDER,
    },
];

export const ORDER_STATUSES = {
    NEW: {
        statusId: 1,
        priority: 1,
        name: "_new_",
        className: "info",
    },
    ASSIGNED: {
        statusId: 6,
        priority: 2,
        name: "_assigned_",
        className: "warning",
    },
    ACCEPTED: {
        statusId: 7,
        priority: 3,
        name: "_accepted_",
        className: "info",
    },
    ON_WAY: {
        statusId: 2,
        priority: 4,
        name: "_ON_WAY_",
        className: "primary",
    },
    IN_PLACE: {
        statusId: 9,
        priority: 5,
        name: "_inplace_",
        className: "success",
    },
    DELIVERED: {
        statusId: 4,
        priority: 6,
        name: "_delivered_",
        className: "default",
    },
    REJECTED: {
        statusId: 8,
        priority: 0,
        name: "_rejected_",
        className: "danger",
    },
    DRAFT: {
        statusId: 0,
        priority: 9,
        name: "_draft_",
        className: "default",
    },
    CANCELED: {
        statusId: 10,
        priority: 0,
        name: "_canceled_",
        className: "default",
    },
    CONFIGURED: {
        statusId: 11,
        priority: 2,
        name: "_configured_",
        className: "success",
    },
    VERIFIED: {
        statusId: 12,
        priority: 6,
        name: "_checked_",
        className: "default",
    },
    COLLECTING: {
        statusId: 13,
        priority: 6,
        name: "_collecting_",
        className: "primary",
    },
    DEFAULT: {
        name: "",
        className: "default",
    },
    statusById(id) {
        switch (id) {
            case ORDER_STATUSES.NEW.statusId:
                return ORDER_STATUSES.NEW;
            case ORDER_STATUSES.ASSIGNED.statusId:
                return ORDER_STATUSES.ASSIGNED;
            case ORDER_STATUSES.ACCEPTED.statusId:
                return ORDER_STATUSES.ACCEPTED;
            case ORDER_STATUSES.ON_WAY.statusId:
                return ORDER_STATUSES.ON_WAY;
            case ORDER_STATUSES.IN_PLACE.statusId:
                return ORDER_STATUSES.IN_PLACE;
            case ORDER_STATUSES.REJECTED.statusId:
                return ORDER_STATUSES.REJECTED;
            case ORDER_STATUSES.DELIVERED.statusId:
                return ORDER_STATUSES.DELIVERED;
            case ORDER_STATUSES.DRAFT.statusId:
                return ORDER_STATUSES.DRAFT;
            case ORDER_STATUSES.CANCELED.statusId:
                return ORDER_STATUSES.CANCELED;
            case ORDER_STATUSES.VERIFIED.statusId:
                return ORDER_STATUSES.VERIFIED;
            case ORDER_STATUSES.CONFIGURED.statusId:
                return ORDER_STATUSES.CONFIGURED;
            case ORDER_STATUSES.COLLECTING.statusId:
                return ORDER_STATUSES.COLLECTING;
            default:
                return ORDER_STATUSES.DEFAULT;
        }
    },
    isOnDelivering(statusId) {
        return (
            statusId === ORDER_STATUSES.ACCEPTED.statusId ||
            statusId === ORDER_STATUSES.ON_WAY.statusId ||
            statusId === ORDER_STATUSES.CONFIGURED.statusId ||
            statusId === ORDER_STATUSES.COLLECTING.statusId ||
            statusId === ORDER_STATUSES.IN_PLACE.statusId
        );
    },
};

export const BOOKED_SERVICE_STATUSES = {
    1: {
        status: "_booked_service_accepted_",
        actions: [
            {
                id: 2,
                name: "_booked_service_driver_on_way_",
            },
        ],
    },

    2: {
        status: "_booked_service_driver_on_way_",
        actions: [
            {
                id: 3,
                name: "_booked_service_order_picked_up_",
            },
        ],
    },

    3: {
        status: "_booked_service_order_picked_up_",
        actions: [
            {
                id: 4,
                name: "_booked_service_order_in_process_",
            },
        ],
    },
    4: {
        status: "_booked_service_order_in_process_",
        actions: [
            {
                id: 5,
                name: "_booked_service_updated_",
            },
        ],
    },
    5: {
        status: "_booked_service_updated_",
        actions: [],
    },
};

export const ORDER_SERVICE_STATUSES = {
    5: {
        status: "_booked_service_updated_",
        actions: [
            {
                id: 6,
                name: "_order_collecting_",
            },
        ],
    },
    6: {
        status: "_order_collecting_",
        actions: [
            {
                id: 7,
                name: "_order_ready_for_deliver_",
            },
        ],
    },
    7: {
        status: "_order_ready_for_deliver_",
        actions: [
            {
                id: 8,
                name: "_order_completely_delivered_",
            },
        ],
    },
};

export const DISTRIBUTOR_TYPES = {
    CAR: { id: 1, iconPath: "car" },
    MOTOBIKE: { id: 2, iconPath: "motobike" },
    BIKE: { id: 3, iconPath: "bike" },
    SCOOTER: { id: 4, iconPath: "scooter" },
    SELF_ROUNDED: { id: 5, iconPath: "scooter" },

    typeById(id) {
        switch (id) {
            case DISTRIBUTOR_TYPES.CAR.id:
                return DISTRIBUTOR_TYPES.CAR;
            case DISTRIBUTOR_TYPES.BIKE.id:
                return DISTRIBUTOR_TYPES.BIKE;
            case DISTRIBUTOR_TYPES.MOTOBIKE.id:
                return DISTRIBUTOR_TYPES.MOTOBIKE;
            case DISTRIBUTOR_TYPES.SCOOTER.id:
                return DISTRIBUTOR_TYPES.SCOOTER;
            case DISTRIBUTOR_TYPES.SELF_ROUNDED.id:
                return DISTRIBUTOR_TYPES.SELF_ROUNDED;
            default:
                return DISTRIBUTOR_TYPES.CAR;
        }
    },
};

const DISTRIBUTOR_ICONS = {
    "car/blue": require("../assets/car/blue.png"),
    "bike/blue": require("../assets/bike/blue.png"),
    "motobike/blue": require("../assets/motobike/blue.png"),
    "scooter/blue": require("../assets/scooter/blue.png"),

    "car/red": require("../assets/car/orange.png"),
    "bike/red": require("../assets/bike/orange.png"),
    "motobike/red": require("../assets/motobike/orange.png"),
    "scooter/red": require("../assets/scooter/orange.png"),

    "car/orange": require("../assets/car/orange.png"),
    "bike/orange": require("../assets/bike/orange.png"),
    "motobike/orange": require("../assets/motobike/orange.png"),
    "scooter/orange": require("../assets/scooter/orange.png"),

    "car/grey": require("../assets/car/grey.png"),
    "bike/grey": require("../assets/bike/grey.png"),
    "motobike/grey": require("../assets/motobike/grey.png"),
    "scooter/grey": require("../assets/scooter/grey.png"),

    "car/green": require("../assets/car/green.png"),
    "bike/green": require("../assets/bike/green.png"),
    "motobike/green": require("../assets/motobike/green.png"),
    "scooter/green": require("../assets/scooter/green.png"),

    "motobike/location_off": require("../assets/motobike/location_off.png"),
    "bike/location_off": require("../assets/bike/location_off.png"),
    "car/location_off": require("../assets/car/location_off.png"),
    "scooter/location_off": require("../assets/scooter/location_off.png"),
};

export const DISTRIBUTOR_STATUSES = {
    AVAILABLE: {
        statusId: 1,
        icon: "/blue",
        className: "text-success",
        name: "_available_",
        bsStyle: "success",
        classBg: "success-bg",
    },
    ASSIGNED: {
        statusId: 5,
        icon: "/red",
        className: "text-assigned",
        name: "_assigned_",
        bsStyle: "success",
        classBg: "assigned-bg",
    },
    ACCEPTED: {
        statusId: 8,
        icon: "/red",
        className: "text-warning",
        name: "_accepted_",
        bsStyle: "danger",
        classBg: "accepted-bg",
    },
    ON_WAY: {
        statusId: 6,
        icon: "/red",
        className: "text-danger",
        name: "_ON_WAY_",
        bsStyle: "danger",
        classBg: "ON_WAY-bg",
    },
    IN_PLACE: {
        statusId: 7,
        icon: "/red",
        className: "text-primary",
        name: "_inplace_",
        bsStyle: "success",
        classBg: "inplace-bg",
    },
    UNAVAILABLE: {
        statusId: 3,
        icon: "/grey",
        className: "text-disabled",
        name: "_unavailable_",
        bsStyle: "default",
        classBg: "unavailable-bg",
    },
    IS_OFFLINE: {
        statusId: 2,
        icon: "/grey",
        className: "text-disabled",
        name: "_is_offline_",
        bsStyle: "default",
        classBg: "unavailable-bg",
    },
    LOCATION_OFF: {
        statusId: 9,
        icon: "/location_off",
        className: "text-disabled",
        name: "_location_is_off_",
        bsStyle: "default",
        classBg: "unavailable-bg",
    },
    DEFAULT: {
        statusId: 0,
        icon: "",
        className: "",
    },
    statusById(id) {
        switch (id) {
            case DISTRIBUTOR_STATUSES.AVAILABLE.statusId:
                return DISTRIBUTOR_STATUSES.AVAILABLE;
            case DISTRIBUTOR_STATUSES.ASSIGNED.statusId:
                return DISTRIBUTOR_STATUSES.ASSIGNED;
            case DISTRIBUTOR_STATUSES.ACCEPTED.statusId:
                return DISTRIBUTOR_STATUSES.ACCEPTED;
            case DISTRIBUTOR_STATUSES.ON_WAY.statusId:
                return DISTRIBUTOR_STATUSES.ON_WAY;
            case DISTRIBUTOR_STATUSES.IN_PLACE.statusId:
                return DISTRIBUTOR_STATUSES.IN_PLACE;
            case DISTRIBUTOR_STATUSES.UNAVAILABLE.statusId:
                return DISTRIBUTOR_STATUSES.UNAVAILABLE;
            case DISTRIBUTOR_STATUSES.IS_OFFLINE.statusId:
                return DISTRIBUTOR_STATUSES.IS_OFFLINE;
            case DISTRIBUTOR_STATUSES.LOCATION_OFF.statusId:
                return DISTRIBUTOR_STATUSES.LOCATION_OFF;
            default:
                return DISTRIBUTOR_STATUSES.DEFAULT;
        }
    },

    iconsByType(type, id) {
        const status = this.statusById(id);
        let suffix = status.icon;

        if (!suffix) {
            return DISTRIBUTOR_ICONS["car/grey"];
        }

        let basePath;
        switch (+type) {
            case DISTRIBUTOR_TYPES.CAR.id:
                basePath = DISTRIBUTOR_TYPES.CAR.iconPath;
                break;
            case DISTRIBUTOR_TYPES.BIKE.id:
                basePath = DISTRIBUTOR_TYPES.BIKE.iconPath;
                break;
            case DISTRIBUTOR_TYPES.MOTOBIKE.id:
                basePath = DISTRIBUTOR_TYPES.MOTOBIKE.iconPath;
                break;
            case DISTRIBUTOR_TYPES.SCOOTER?.id:
                basePath = DISTRIBUTOR_TYPES.SCOOTER.iconPath;
                break;
            default:
                basePath = DISTRIBUTOR_TYPES.CAR.iconPath;
        }

        const key = basePath + suffix;

        return DISTRIBUTOR_ICONS[key] || DISTRIBUTOR_ICONS["car/grey"];
    },

    isAvailable(id) {
        return id === DISTRIBUTOR_STATUSES.AVAILABLE.statusId;
    },
};

export const DISTRIBUTOR_SANITARY_BOOK_STATUSES = {
    PENDING: {
        statusId: 0,
        name: "_sanitary_book_pending_",
        bsStyle: "warning",

    },
    APPROVED: {
        statusId: 1,
        name: "_approved_",
        bsStyle: "success",
    },
    REJECTED: {
        statusId: 2,
        name: "_rejected_status",
        bsStyle: "danger",
    },
    LEFT: {
        statusId: 3,
        name: "_expires_on_",
        bsStyle: "warning",
    },
    EXPIRED: {
        statusId: 4,
        name: "_status_expired_",
        bsStyle: "danger",
    },
    NOT_ATTACHED: {
        statusId: null,
        name: "_not_attached_",
        bsStyle: "default",
    },
    statusById(id) {
        switch (id) {
            case DISTRIBUTOR_SANITARY_BOOK_STATUSES.PENDING.statusId:
                return DISTRIBUTOR_SANITARY_BOOK_STATUSES.PENDING;
            case DISTRIBUTOR_SANITARY_BOOK_STATUSES.APPROVED.statusId:
                return DISTRIBUTOR_SANITARY_BOOK_STATUSES.APPROVED;
            case DISTRIBUTOR_SANITARY_BOOK_STATUSES.REJECTED.statusId:
                return DISTRIBUTOR_SANITARY_BOOK_STATUSES.REJECTED;
            case DISTRIBUTOR_SANITARY_BOOK_STATUSES.LEFT.statusId:
                return DISTRIBUTOR_SANITARY_BOOK_STATUSES.LEFT;
            case DISTRIBUTOR_SANITARY_BOOK_STATUSES.EXPIRED.statusId:
                return DISTRIBUTOR_SANITARY_BOOK_STATUSES.EXPIRED;
            default:
                return DISTRIBUTOR_SANITARY_BOOK_STATUSES.NOT_ATTACHED;
        }
    },
};

export const GIFT_CARD_STATUSES = {
    DRAFT: {
        statusId: 0,
        name: "_draft_",
        style: "default",
    },
    RESERVED: {
        statusId: 1,
        name: "_reserved_",
        style: "warning",
    },
    SOLD: {
        statusId: 2,
        name: "_sold_",
        style: "primary",
    },
    ACTIVE: {
        statusId: 3,
        name: "_active_",
        style: "success",
    },
    USED: {
        statusId: 4,
        name: "_used_",
        style: "info",
    },
    INACTIVE: {
        statusId: 5,
        name: "_in_active_",
        style: "default",
    },
    statusById(id) {
        switch (id) {
            case GIFT_CARD_STATUSES.DRAFT.statusId:
                return GIFT_CARD_STATUSES.DRAFT;
            case GIFT_CARD_STATUSES.RESERVED.statusId:
                return GIFT_CARD_STATUSES.RESERVED;
            case GIFT_CARD_STATUSES.SOLD.statusId:
                return GIFT_CARD_STATUSES.SOLD;
            case GIFT_CARD_STATUSES.ACTIVE.statusId:
                return GIFT_CARD_STATUSES.ACTIVE;
            case GIFT_CARD_STATUSES.USED.statusId:
                return GIFT_CARD_STATUSES.USED;
            case GIFT_CARD_STATUSES.INACTIVE.statusId:
                return GIFT_CARD_STATUSES.INACTIVE;
            default:
                return {};
        }
    },
    statuses() {
        return [
            GIFT_CARD_STATUSES.DRAFT,
            GIFT_CARD_STATUSES.RESERVED,
            GIFT_CARD_STATUSES.SOLD,
            GIFT_CARD_STATUSES.ACTIVE,
            GIFT_CARD_STATUSES.USED,
            GIFT_CARD_STATUSES.INACTIVE,
        ];
    },
};
export const GIFT_CARD_SHOP_ID = "978";
export const GIFT_CARD_SHOP_NAME = "Նվեր քարտ";

export const GIFT_CARD_TYPES = {
    PHYSICAL: {
        typeId: 0,
        name: "_physical_",
    },
    ELECTRONIC: {
        typeId: 1,
        name: "_electronic_",
    },
    typeById(id) {
        switch (id) {
            case GIFT_CARD_TYPES.PHYSICAL.typeId:
                return GIFT_CARD_TYPES.PHYSICAL;
            case GIFT_CARD_TYPES.ELECTRONIC.typeId:
                return GIFT_CARD_TYPES.ELECTRONIC;
            default:
                return {};
        }
    },
    types() {
        return [GIFT_CARD_TYPES.PHYSICAL, GIFT_CARD_TYPES.ELECTRONIC];
    },
};

export const SOURCES = {
    WEB: {
        sourceId: 0,
        name: "_web_",
        className: "success",
    },
    MOBILE: {
        sourceId: 1,
        name: "_mobile_",
        className: "info",
    },
    CALL_CENTER: {
        sourceId: 2,
        name: "_call_center_",
        className: "primary",
    },
    EXTERNAL: {
        sourceId: 3,
        name: "_external_",
        className: "warning",
    },
    APP: {
        sourceId: 4,
        name: "_app_",
        className: "info",
    },
    sourceById(id) {
        switch (id) {
            case SOURCES.WEB.sourceId:
                return SOURCES.WEB;
            case SOURCES.MOBILE.sourceId:
                return SOURCES.MOBILE;
            case SOURCES.EXTERNAL.sourceId:
                return SOURCES.EXTERNAL;
            case SOURCES.APP.sourceId:
                return SOURCES.APP;
            case SOURCES.CALL_CENTER.sourceId:
            default:
                return SOURCES.CALL_CENTER;
        }
    },
};

export const PRODUCT_MEASUREMENTS = {
    KG: {
        name: "_kg_",
        id: 2,
    },
    UNIT: {
        name: "_unit_",
        id: 1,
    },
    measurementById(id) {
        switch (id) {
            case this.KG.id:
                return this.KG;
            case this.UNIT.id:
            default:
                return this.UNIT;
        }
    },
};

export const PAYMENT_METHODS = [
    {
        id: 3,
        name: "Կանխիկ",
    },
    {
        id: 4,
        name: "FastShift",
    },
    {
        id: 6,
        name: "Idram",
    },
    {
        id: 7,
        name: "POS",
    },
    {
        id: 8,
        name: "Վճարային քարտ",
    },
    {
        id: 9,
        name: "Նվեր քարտ",
    },
    {
        id: 11,
        name: "Բանկային փոխանցում",
    },
    {
        id: 12,
        name: "PayX",
    },
    {
        id: 13,
        name: "TelCell",
    },
    {
        id: 14,
        name: "Վճարված է վաուչերով",
    },
    {
        id: 15,
        name: "vPOS",
    },
    {
        id: 16,
        name: "Վճարված է ռեստորանին",
    },
];

export const WALLET_TYPES = {
    BONUS: 0,
    CORPORATE_BONUS: 1,
};

export const PAYMENT_TYPES = {
    AFTER_DELIVERY: {
        id: 3,
        name: "Կանխիկ",
        disabled: false,
        canBeChanged: true,
    },
    FASTSHIFT: {
        id: 4,
        name: "FastShift",
        disabled: true,
        canBeChanged: false,
    },
    IDRAM: {
        id: 6,
        name: "Idram",
        disabled: true,
        canBeChanged: false,
    },
    POS_TERMINAL: {
        id: 7,
        name: "POS",
        disabled: false,
        canBeChanged: true,
    },
    BY_CARD: {
        id: 8,
        name: "Վճարային քարտ",
        disabled: true,
        canBeChanged: false,
    },
    GIFT_CARD: {
        id: 9,
        name: "Նվեր քարտ",
        disabled: false,
        canBeChanged: true,
    },
    BOUND_CARD: {
        id: 10,
        name: "Վճարային քարտ",
        disabled: true,
        canBeChanged: false,
    },
    BANK_TRANSACTION: {
        id: 11,
        name: "Բանկային փոխանցում",
        disabled: false,
        canBeChanged: true,
    },
    PAY_X: {
        id: 12,
        name: "PayX",
        disabled: true,
        canBeChanged: false,
    },
    TEL_CELL: {
        id: 13,
        name: "TelCell",
        disabled: true,
        canBeChanged: false,
    },
    LOAN: {
        id: 14,
        name: "Վճարված է վաուչերով",
        disabled: false,
        canBeChanged: false,
    },
    V_POS: {
        id: 15,
        name: "vPOS",
        disabled: false,
        canBeChanged: false,
    },
    R_PAID: {
        id: 16,
        name: "Վճարված է ռեստորանին",
        disabled: true,
        canBeChanged: false,
    },
    OPERATIONAL_RISKS_COSTS: {
        id: 19,
        name: "ԳՌ ծախսեր",
        disabled: false,
        canBeChanged: false,
    },
    BONUS: {
        id: 17,
        name: "Բոնուս",
        disabled: true,
        canBeChanged: false,
        walletType: WALLET_TYPES.BONUS,
    },

    CORPORATE_BONUS: {
        id: 18,
        name: "Կորպորատիվ բոնուս",
        disabled: true,
        canBeChanged: false,
        walletType: WALLET_TYPES.CORPORATE_BONUS,
    },
    APPLE_PAY: {
        id: 20,
        name: "ApplePay",
        disabled: true,
        canBeChanged: false,
    },
    MY_AMERIA_PAY: {
        id: 21,
        name: "MyAmeriaPay",
        disabled: true,
        canBeChanged: false,
    },
    EASY_PAY: {
        id: 22,
        name: "EasyPay",
        disabled: true,
        canBeChanged: false,
    },
    GOOGLE_PAY: {
        id: 23,
        name: "Google Pay",
        disabled: true,
        canBeChanged: false,
    },

    getNotEditablePaymentMethods() {
        return [
            this.BY_CARD.id,
            this.BOUND_CARD.id,
            this.PAY_X.id,
            this.R_PAID.id,
            this.TEL_CELL.id,
            this.V_POS.id,
            this.IDRAM.id,
            this.FASTSHIFT.id,
            this.LOAN.id,
            this.MY_AMERIA_PAY.id,
            this.EASY_PAY.id,
            this.GOOGLE_PAY.id,
        ];
    },

    paymentMethods(currentPaymentType = null) {
        const shouldDisableCashAndPos = currentPaymentType === this.MY_AMERIA_PAY.id || currentPaymentType === this.APPLE_PAY.id;

        return [
            {
                name: this.AFTER_DELIVERY.name,
                value: this.AFTER_DELIVERY.id,
                disabled: shouldDisableCashAndPos,
                canBeChanged: true,
            },
            {
                name: this.FASTSHIFT.name,
                value: this.FASTSHIFT.id,
                disabled: true,
                canBeChanged: false,
            },
            {
                name: this.IDRAM.name,
                value: this.IDRAM.id,
                disabled: true,
                canBeChanged: false,
            },
            {
                name: this.POS_TERMINAL.name,
                value: this.POS_TERMINAL.id,
                disabled: shouldDisableCashAndPos,
                canBeChanged: true,
            },
            {
                name: this.BY_CARD.name,
                value: this.BY_CARD.id,
                disabled: true,
                canBeChanged: false,
            },
            {
                name: this.GIFT_CARD.name,
                value: this.GIFT_CARD.id,
                disabled: true,
                canBeChanged: true,
            },
            {
                name: this.BANK_TRANSACTION.name,
                value: this.BANK_TRANSACTION.id,
                disabled: true,
                canBeChanged: true,
            },
            {
                name: this.PAY_X.name,
                value: this.PAY_X.id,
                disabled: true,
                canBeChanged: false,
            },
            {
                name: this.TEL_CELL.name,
                value: this.TEL_CELL.id,
                disabled: true,
                canBeChanged: false,
            },
            {
                name: this.LOAN.name,
                value: this.LOAN.id,
                disabled: true,
                canBeChanged: false,
            },
            {
                name: this.V_POS.name,
                value: this.V_POS.id,
                disabled: true,
                canBeChanged: false,
            },
            {
                name: this.R_PAID.name,
                value: this.R_PAID.id,
                disabled: true,
                canBeChanged: false,
            },
            {
                name: this.OPERATIONAL_RISKS_COSTS.name,
                value: this.OPERATIONAL_RISKS_COSTS.id,
                disabled: false,
                canBeChanged: false,
            },
            {
                name: this.BONUS.name,
                value: this.BONUS.id,
                disabled: true,
                canBeChanged: false,
                walletType: WALLET_TYPES.BONUS,
            },
            {
                name: this.CORPORATE_BONUS.name,
                value: this.CORPORATE_BONUS.id,
                disabled: true,
                canBeChanged: false,
                walletType: WALLET_TYPES.CORPORATE_BONUS,
            },
            {
                name: this.APPLE_PAY.name,
                value: this.APPLE_PAY.id,
                disabled: true,
                canBeChanged: false,
            },
            {
                name: this.MY_AMERIA_PAY.name,
                value: this.MY_AMERIA_PAY.id,
                disabled: true,
                canBeChanged: false,
            },
            {
                name: this.EASY_PAY.name,
                value: this.EASY_PAY.id,
                disabled: true,
                canBeChanged: false,
            },
            {
                name: this.GOOGLE_PAY.name,
                value: this.GOOGLE_PAY.id,
                disabled: true,
                canBeChanged: false,
            },
        ];
    },
    paymentMethodsById(id) {
        switch (id) {
            case this.AFTER_DELIVERY.id:
                return this.AFTER_DELIVERY;
            case this.FASTSHIFT.id:
                return this.FASTSHIFT;
            case this.IDRAM.id:
                return this.IDRAM;
            case this.POS_TERMINAL.id:
                return this.POS_TERMINAL;
            case this.BY_CARD.id:
                return this.BY_CARD;
            case this.GIFT_CARD.id:
                return this.GIFT_CARD;
            case this.BOUND_CARD.id:
                return this.BOUND_CARD;
            case this.BANK_TRANSACTION.id:
                return this.BANK_TRANSACTION;
            case this.PAY_X.id:
                return this.PAY_X;
            case this.OPERATIONAL_RISKS_COSTS.id:
                return this.OPERATIONAL_RISKS_COSTS;
            case this.TEL_CELL.id:
                return this.TEL_CELL;
            case this.LOAN.id:
                return this.LOAN;
            case this.V_POS.id:
                return this.V_POS;
            case this.R_PAID.id:
                return this.R_PAID;
            case this.APPLE_PAY.id:
                return this.APPLE_PAY;
            case this.MY_AMERIA_PAY.id:
                return this.MY_AMERIA_PAY;
            case this.EASY_PAY.id:
                return this.EASY_PAY;
            case this.GOOGLE_PAY.id:
                return this.GOOGLE_PAY;
            case this.CORPORATE_BONUS.id:
                return this.CORPORATE_BONUS;
            case this.BONUS.id:
                return this.BONUS;
            default:
                return this.AFTER_DELIVERY;
        }
    },
};

export const TURNOVER_PAYMENT_TYPES = {
    POS: { id: 1, name: "POS", disabled: false, canBeChanged: true },
    GIFT_CARD: { id: 2, name: "Gift Card", disabled: false, canBeChanged: true },
    BONUS: { id: 3, name: "Bonus", disabled: false, canBeChanged: true },
    DISCOUNT: { id: 4, name: "Discount", disabled: false, canBeChanged: true },
    BANK_CARD: { id: 5, name: "Bank Card", disabled: false, canBeChanged: true },
    FAST_SHIFT: { id: 6, name: "FastShift", disabled: true, canBeChanged: false },
    IDRAM: { id: 7, name: "Idram", disabled: true, canBeChanged: false },
    BANK_TRANSACTION: { id: 8, name: "Bank Transfer", disabled: false, canBeChanged: true },
    TEL_CELL: { id: 9, name: "Telcell", disabled: false, canBeChanged: true },
    V_POS: { id: 10, name: "Virtual POS", disabled: false, canBeChanged: true },
    R_PAID: { id: 11, name: "Prepaid (R Paid)", disabled: false, canBeChanged: true },
    OPERATIONAL_RISK_COST: { id: 12, name: "Operational Risk Cost", disabled: true, canBeChanged: false },
    APPLE_PAY: { id: 13, name: "Apple Pay", disabled: false, canBeChanged: true },
    MY_AMERIA_PAY: { id: 14, name: "MyAmeria Pay", disabled: false, canBeChanged: true },
    ABROAD: { id: 15, name: "Abroad Payment", disabled: false, canBeChanged: true },
    BIND_CARD: { id: 16, name: "Bind Card", disabled: false, canBeChanged: true },
    PAY_X: { id: 17, name: "PayX", disabled: false, canBeChanged: true },
    EASY_PAY: { id: 18, name: "EasyPay", disabled: false, canBeChanged: true },
    GOOGLE_PAY: { id: 19, name: "Google Pay", disabled: false, canBeChanged: true },

    paymentMethods() {
        return Object.values(this)
            .filter(item => typeof item === "object" && item.id)
            .map(item => ({
                name: item.name,
                value: item.id,
                disabled: item.disabled,
                canBeChanged: item.canBeChanged,
                ...(item.id === this.BONUS.id && {
                    walletType: WALLET_TYPES?.BONUS,
                }),
            }));
    },

    paymentMethodsById(id) {
        const method = Object.values(this).find(
            item => typeof item === "object" && item.id === id,
        );

        return method || this.POS;
    },
};


export const DISTRIBUTOR_DEED_TYPES = {
    INDIVIDUAL: 1,
    SUMMARIZED: 2,
};

export const CALL_TYPES = {
    NEW_ORDER: 0,
    RESTAURANT_ORDER: 1,
    CHANGE_ORDER: 2,
    OTHER: 3,
    SADA_WATER_COLA: 4,
    DELIVERY_SERVICE: 5,
};

export const CALL_REASONS = [
    {
        label: "Նոր պատվեր",
        value: CALL_TYPES.NEW_ORDER,
    },
    {
        label: "Ռեստորանի պատվեր",
        value: CALL_TYPES.RESTAURANT_ORDER,
    },
    {
        label: "Փոփոխել պատվերը",
        value: CALL_TYPES.CHANGE_ORDER,
    },
    {
        label: "Այլ",
        value: CALL_TYPES.OTHER,
    },
    {
        label: "Առաքման ծառայություն",
        value: CALL_TYPES.DELIVERY_SERVICE,
    },
    {
        label: "«ՍԱԴԱ ԳԼՈԲԱԼ ԴԵԼԻՎԵՐԻ ՍԵՆԹԸՐ» Հայաստան 02834923",
        value: CALL_TYPES.SADA_WATER_COLA,
    },
];

export const USER_ROLES = {
    CUSTOMER: 0,
    DISTRIBUTOR: 1,
    MANAGER: 2,
    SERVER: 3,
    CALL_CENTER: 4,
    ORDER_MANAGER: 5,
    ADMIN: 6,
    ACCOUNTANT: 7,
    PARTNER_MANAGER: 8,
    SUPER_ADMIN: 9,
    SUPPLIER: 10,
    API_USER: 11,
    DISTRIBUTION_PARTNER: 12,
    B2B_USER: 13,
};

export const SUPPLIER_USER_TYPES = {
    BRANCH: 1,
    MANAGER: 2,
};

export const SUPPLIER_USER_TYPE_NAMES = [
    {
        label: "_branch_",
        value: SUPPLIER_USER_TYPES.BRANCH,
        disabled: false,
    },
    {
        label: "_manager_",
        value: SUPPLIER_USER_TYPES.MANAGER,
        disabled: true,
    },
];

export const SANITARY_BOOK_STATUSES = {
    default: 0,
    PENDING: 0,
    APPROVED: 1,
    REJECTED: 2,
    STATUS: {
        0: { id: 0, name: "_sanitary_book_pending_", className: "warning" },
        1: { id: 1, name: "_sanitary_book_approved_", className: "success" },
        2: { id: 2, name: "_sanitary_book_rejected_", className: "danger" },
    },
    statusById(id) {
        return this.STATUS[id] || this.STATUS[this.default] || {};
    },
};

export const SANITARY_BOOK_REJECT_REASONS = {
    UNCLEAR_PHOTO: 1,
    MISSING_PAGE: 2,
    WRONG_DOCUMENT: 3,
    NOT_OWN_DOCUMENT: 4,
    NO_STAMP: 5,
    EXPIRED_DOCUMENT: 6,
    ALTERED_DOCUMENT: 7,
    INCOMPLETE_DOCUMENT: 8,
    REJECTION_REASONS: [
        { value: 1, label: "_sanitary_book_reason_unclear_photo_" },
        { value: 2, label: "_sanitary_book_reason_missing_page_" },
        { value: 3, label: "_sanitary_book_reason_wrong_document_" },
        { value: 4, label: "_sanitary_book_reason_not_own_document_" },
        { value: 5, label: "_sanitary_book_reason_no_stamp_" },
        { value: 6, label: "_sanitary_book_reason_expired_document_" },
        { value: 7, label: "_sanitary_book_reason_altered_document_" },
        { value: 8, label: "_sanitary_book_reason_incomplete_document_" },
    ],
    reasonById(id) {
        return this.REJECTION_REASONS.find(reason => reason.value === id) || null;
    },
};

export const ETA = {
    DANGER: {
        value: 0,
        className: "eta-danger",
    },
    WARNING: {
        value: 10,
        className: "eta-warning",
    },
    RESTAURANT: {
        value: 45,
        className: "eta-restaurant",
    },
    NOT_ASSIGNED: {
        value: 55,
        className: "buy-red",
    },
};

export const ADDITIONAL_MINUTES = 55;

export const USER_ROLE_NAMES = [
    {
        label: "_customer_",
        role: USER_ROLES.CUSTOMER,
    },
    {
        label: "_distributors_",
        role: USER_ROLES.DISTRIBUTOR,
    },
    {
        label: "_manager_",
        role: USER_ROLES.MANAGER,
    },
    {
        label: "_server_",
        role: USER_ROLES.SERVER,
    },
    {
        label: "_call_center_",
        role: USER_ROLES.CALL_CENTER,
    },
    {
        label: "_order_manager_",
        role: USER_ROLES.ORDER_MANAGER,
    },
    {
        label: "_administrator_",
        role: USER_ROLES.ADMIN,
    },
    {
        label: "_accontter_",
        role: USER_ROLES.ACCOUNTANT,
    },
    {
        label: "_partner_manager_",
        role: USER_ROLES.PARTNER_MANAGER,
    },
    {
        label: "_super_admin_",
        role: USER_ROLES.SUPER_ADMIN,
    },
    {
        label: "_supplier_",
        role: USER_ROLES.SUPPLIER,
    },
    {
        label: "_api_user_",
        role: USER_ROLES.API_USER,
    },
    {
        label: "_distribution_partner_",
        role: USER_ROLES.DISTRIBUTION_PARTNER,
    },
    {
        label: "_b2b_user_",
        role: USER_ROLES.B2B_USER,
    },
];

export const DELETED_USER_ROLE_NAMES = [
    {
        label: "_deleted_customer_",
        role: USER_ROLES.CUSTOMER,
    },
    {
        label: "_deleted_distributors_",
        role: USER_ROLES.DISTRIBUTOR,
    },
    {
        label: "_deleted_manager_",
        role: USER_ROLES.MANAGER,
    },
    {
        label: "_deleted_server_",
        role: USER_ROLES.SERVER,
    },
    {
        label: "_deleted_call_center_",
        role: USER_ROLES.CALL_CENTER,
    },
    {
        label: "_deleted_order_manager_",
        role: USER_ROLES.ORDER_MANAGER,
    },
    {
        label: "_deleted_administrator_",
        role: USER_ROLES.ADMIN,
    },
    {
        label: "_deleted_accounter_",
        role: USER_ROLES.ACCOUNTANT,
    },
    {
        label: "_deleted_partner_manager_",
        role: USER_ROLES.PARTNER_MANAGER,
    },
    {
        label: "_deleted_super_admin_",
        role: USER_ROLES.SUPER_ADMIN,
    },
    {
        label: "_deleted_supplier_",
        role: USER_ROLES.SUPPLIER,
    },
    {
        label: "_deleted_api_user_",
        role: USER_ROLES.API_USER,
    },
    {
        label: "_deleted_distribution_partner_",
        role: USER_ROLES.DISTRIBUTION_PARTNER,
    },
];

export const MAP_DEFAULT_VIEWPORT = {
    lat: 40.181541,
    lng: 44.5124867,
};

export const ENTER_KEY = {
    keyCode: 13,
};

export const ORDER = {
    EDITED: {
        className: "buy-grean",
    },
    REJECTED: {
        className: "rejected",
    },
    NOT_ASSIGNED: {
        className: "buy-red",
    },
};

export const PAGINATION = {
    size: 25,
    perPageList: [
        {
            text: "10",
            value: 10,
        },
        {
            text: "25",
            value: 25,
        },
        {
            text: "50",
            value: 50,
        },
        {
            text: "100",
            value: 100,
        },
        {
            text: "200",
            value: 200,
        },
        {
            text: "500",
            value: 500,
        },
        {
            text: "1000",
            value: 1000,
        },
        {
            text: "2000",
            value: 2000,
        },
    ],
};

export const ERRORS = {
    network_error: {
        title: "_server_disconnected_",
        message: "_refresh_page_",
        error: "Network Error",
    },
    forced_close: {
        reason: ["forced close", "io server disconnect"],
    },
};

export const ORDER_DETAILS_MODE = {
    MODES: {
        edit_mode: 0,
        cancel_mode: 1,
        restore_mode: 2,
    },
    DATA: [
        {
            label: "_edit_",
            value: 0,
        },
        {
            label: "_cancel_",
            value: 1,
        },
        {
            label: "_restore_",
            value: 2,
        },
    ],
};

export const CANCEL_REASONS = {
    CUSTOMER_DUPLICATE: {
        id: 0,
        name: "Պատվիրատուի կողմից կրկնօրինակ",
    },
    CUSTOMER_DELAYED: {
        id: 1,
        name: "Պատվիրատուի կողմից ուշացման պատճառով",
    },
    CUSTOMER_CANCEL: {
        id: 2,
        name: "Պատվիրատուի կողմից սխալ պատվեր",
    },
    CUSTOMER_RESTURANT_REASON: {
        id: 5,
        name: "Պատվիրատուի կողմից ռեստորանը ուշ է բացվելու",
    },
    CALL_CENTER_WRONG_ORDER: {
        id: 6,
        name: "Զանգերի կենտրոն սխալ պատվեր",
    },
    CALL_CENTER_DUPLICATE: {
        id: 7,
        name: "Զանգերի կենտրոն կրկնօրինակ",
    },
    CALL_CENTER_RESTURANT_REASON: {
        id: 8,
        name: "Զանգերի կենտրոն մատակարարի կողմից",
    },
    RESTURANT_CLOSED: {
        id: 9,
        name: "Մատակարար փակ է",
    },
    PRODUCT_NOT_EXIST: {
        id: 10,
        name: "Մատակարար տեսականին առկա չէ",
    },
    TEST: {
        id: 11,
        name: "Թեստ",
    },
    NETWORK_PAY: {
        id: 12,
        name: "Առցանց վճարում",
    },
    ADITIONAL_PAY: {
        id: 13,
        name: "Չչեղարկել, լրացուցիչ վճարում ",
    },
    DANGER: {
        id: 14,
        name: "Ֆրոդ / կասկածելի գործարք",
    },
    ELECTRIC_PROBLEM: {
        id: 15,
        name: "Մատակարարը լույս/գազ չունի",
    },
    RESTURANT_WAIT: {
        id: 16,
        name: "Մատարարարը ուշացնում է",
    },
    RESTURANT_UNAVILABLE: {
        id: 17,
        name: "Մատակարարը անհասանելի է",
    },
    CUSTOMER_UNAVILABLE: {
        id: 18,
        name: "Հաճախորդը անհասանելի է",
    },
    CUSTOMER_PICKUP: {
        id: 19,
        name: "Հաճախորդը կմոտենա / pickup",
    },
    OTHER: {
        id: 3,
        name: "Այլ",
    },
    MERGED: {
        id: 4,
        name: "Միավորված",
    },
    cancelReasons() {
        return [
            {
                label: this.CUSTOMER_DUPLICATE.name,
                value: this.CUSTOMER_DUPLICATE.id,
            },
            {
                label: this.CUSTOMER_DELAYED.name,
                value: this.CUSTOMER_DELAYED.id,
            },
            {
                label: this.CUSTOMER_CANCEL.name,
                value: this.CUSTOMER_CANCEL.id,
            },
            {
                label: this.CUSTOMER_RESTURANT_REASON.name,
                value: this.CUSTOMER_RESTURANT_REASON.id,
            },
            {
                label: this.CALL_CENTER_WRONG_ORDER.name,
                value: this.CALL_CENTER_WRONG_ORDER.id,
            },
            {
                label: this.CALL_CENTER_DUPLICATE.name,
                value: this.CALL_CENTER_DUPLICATE.id,
            },
            {
                label: this.CALL_CENTER_RESTURANT_REASON.name,
                value: this.CALL_CENTER_RESTURANT_REASON.id,
            },
            {
                label: this.RESTURANT_CLOSED.name,
                value: this.RESTURANT_CLOSED.id,
            },
            {
                label: this.PRODUCT_NOT_EXIST.name,
                value: this.PRODUCT_NOT_EXIST.id,
            },
            {
                label: this.NETWORK_PAY.name,
                value: this.NETWORK_PAY.id,
            },
            {
                label: this.ADITIONAL_PAY.name,
                value: this.ADITIONAL_PAY.id,
            },
            {
                label: this.DANGER.name,
                value: this.DANGER.id,
            },
            {
                label: this.ELECTRIC_PROBLEM.name,
                value: this.ELECTRIC_PROBLEM.id,
            },
            {
                label: this.RESTURANT_WAIT.name,
                value: this.RESTURANT_WAIT.id,
            },
            {
                label: this.RESTURANT_UNAVILABLE.name,
                value: this.RESTURANT_UNAVILABLE.id,
            },
            {
                label: this.CUSTOMER_UNAVILABLE.name,
                value: this.CUSTOMER_UNAVILABLE.id,
            },
            {
                label: this.CUSTOMER_PICKUP.name,
                value: this.CUSTOMER_PICKUP.id,
            },
            {
                label: this.TEST.name,
                value: this.TEST.id,
            },
            {
                label: this.OTHER.name,
                value: this.OTHER.id,
            },
            {
                label: this.MERGED.name,
                value: this.MERGED.id,
            },
        ];
    },
    cancelReasonById(id) {
        switch (id) {
            case this.CUSTOMER_DUPLICATE.id:
                return this.CUSTOMER_DUPLICATE;
            case this.CUSTOMER_DELAYED.id:
                return this.CUSTOMER_DELAYED;
            case this.CUSTOMER_CANCEL.id:
                return this.CUSTOMER_CANCEL;
            case this.CUSTOMER_RESTURANT_REASON.id:
                return this.CUSTOMER_RESTURANT_REASON;
            case this.CALL_CENTER_WRONG_ORDER.id:
                return this.CALL_CENTER_WRONG_ORDER;
            case this.CALL_CENTER_DUPLICATE.id:
                return this.CALL_CENTER_DUPLICATE;
            case this.CALL_CENTER_RESTURANT_REASON.id:
                return this.CALL_CENTER_RESTURANT_REASON;
            case this.RESTURANT_CLOSED.id:
                return this.RESTURANT_CLOSED;
            case this.PRODUCT_NOT_EXIST.id:
                return this.PRODUCT_NOT_EXIST;
            case this.NETWORK_PAY.id:
                return this.NETWORK_PAY;
            case this.ADITIONAL_PAY.id:
                return this.ADITIONAL_PAY;
            case this.DANGER.id:
                return this.DANGER;
            case this.ELECTRIC_PROBLEM.id:
                return this.ELECTRIC_PROBLEM;
            case this.RESTURANT_WAIT.id:
                return this.RESTURANT_WAIT;
            case this.RESTURANT_UNAVILABLE.id:
                return this.RESTURANT_UNAVILABLE;
            case this.CUSTOMER_UNAVILABLE.id:
                return this.CUSTOMER_UNAVILABLE;
            case this.CUSTOMER_PICKUP.id:
                return this.CUSTOMER_PICKUP;
            case this.TEST.id:
                return this.TEST;
            case this.OTHER.id:
                return this.OTHER;
            case this.MERGED.id:
                return this.MERGED;
            default:
                return this.CUSTOMER_DUPLICATE;
        }
    },
};

// export const CANCEL_REASONS_DATA = [
//     {
//         label: 'Կրկնօրինակ',
//         value: CANCEL_REASONS.DUPLICATE
//     }, {
//         label: 'Ուշացված',
//         value: CANCEL_REASONS.DELAYED
//     }, {
//         label: 'Պատվիրատուի հրաժարում',
//         value: CANCEL_REASONS.CUSTOMER_CANCEL
//     }, {
//         label: 'Այլ',
//         value: CANCEL_REASONS.OTHER
//     }, {
//         label: 'Միավորված',
//         value: CANCEL_REASONS.MERGED
//     }
// ];

export const RECEIVER_ADDRESS = [
    {
        key: "address",
        label: "_delivery_address_",
        required: true,
    },
    {
        key: "additionalAddress",
        label: "_additional_address_",
        required: false,
    },
];

export const ORDER_KEYS = {
    FIRST_DELIVERY_TIME: "deliveryTime.0.date",
};

export const B2B_SERVICE_HINTS = {
    NONE: 1,
    PrintReceiptWithTIN: 2,
    InvoiceBUYAM: 3,
};

export const RESTAURANT_COOPERATION_TYPES = {
    // CASH: {
    //     id: 0,
    //     name: "Կանխիկ",
    // },
    CREDIT: {
        id: 1,
        name: "Անկանխիկ",
    },
    cooperationMethods() {
        return [
            // {
            //     name: this.CASH.name,
            //     value: this.CASH.id,
            // },
            {
                name: this.CREDIT.name,
                value: this.CREDIT.id,
            },
        ];
    },
    paymentMethodsById(id) {
        switch (id) {
            // case this.CASH.id:
            //     return this.CASH;
            case this.CREDIT.id:
                return this.CREDIT;
            default:
                return this.CREDIT;
        }
    },
};

export const RESTAURANT_SOURCE_OF_INCOME = {
    COMMISSION: {
        id: 0,
        name: "Կոմիսիոն վճար",
    },
    RESELL: {
        id: 1,
        name: "Վերավաճառք",
    },
    source() {
        return [
            {
                name: this.COMMISSION.name,
                value: this.COMMISSION.id,
            },
            {
                name: this.RESELL.name,
                value: this.RESELL.id,
            },
        ];
    },
    sourceById(id) {
        switch (id) {
            case this.COMMISSION.id:
                return this.COMMISSION;
            case this.RESELL.id:
                return this.RESELL;
            default:
                return {};
        }
    },
};

export const INCOME_SOURCE = {
    SERVICE: {
        id: 1,
        name: "Ծառայությունների համար",
    },
    PRODUCT: {
        id: 2,
        name: "Ապրանքների համար",
    },
    source() {
        return [
            {
                name: this.SERVICE.name,
                value: this.SERVICE.id,
            },
            {
                name: this.PRODUCT.name,
                value: this.PRODUCT.id,
            },
        ];
    },
    sourceById(id) {
        switch (id) {
            case this.SERVICE.id:
                return this.SERVICE;
            case this.PRODUCT.id:
                return this.PRODUCT;
            default:
                return {};
        }
    },
};

export const RESTAURANT_COOPERATION_METHODS = {
    ALLAMOUNT: {
        id: 0,
        name: "Ամբողջ գումարը",
    },
    PERCENT: {
        id: 1,
        name: "Շահույթը պահած",
    },
    cooperationMethods() {
        return [
            {
                name: this.ALLAMOUNT.name,
                value: this.ALLAMOUNT.id,
            },
            {
                name: this.PERCENT.name,
                value: this.PERCENT.id,
            },
        ];
    },
    cooperationMethodsById(id) {
        switch (id) {
            case this.ALLAMOUNT.id:
                return this.ALLAMOUNT;
            case this.PERCENT.id:
                return this.PERCENT;
            default:
                return {};
        }
    },
};

export const RESTAURANT_PAYERS = {
    // DISTRIBUTOR: {
    //     id: 0,
    //     name: "Վճարում առաքիչի կողմից",
    // },
    ACCOUNTANT: {
        id: 1,
        name: "Վճարում հաշվապահություն",
    },
    restaurantPayers() {
        return [
            // {
            //     name: this.DISTRIBUTOR.name,
            //     value: this.DISTRIBUTOR.id,
            // },
            {
                name: this.ACCOUNTANT.name,
                value: this.ACCOUNTANT.id,
            },
        ];
    },
    restaurantPayersById(id) {
        switch (id) {
            // case this.DISTRIBUTOR.id:
            //     return this.DISTRIBUTOR;
            case this.ACCOUNTANT.id:
                return this.ACCOUNTANT;
            default:
                return {};
        }
    },
};

export const RESTAURANT_TYPES = {
    RESTAURANT: {
        id: 0,
        name: "Ռեստորան",
    },
    SHOP: {
        id: 1,
        name: "Խանութ",
    },
    SUPERMARKET: {
        id: 2,
        name: "Սուպերմարկետ",
    },
    types() {
        return [
            {
                name: this.RESTAURANT.name,
                value: this.RESTAURANT.id,
            },
            {
                name: this.SHOP.name,
                value: this.SHOP.id,
            },
            {
                name: this.SUPERMARKET.name,
                value: this.SUPERMARKET.id,
            },
        ];
    },
    typeById(id) {
        switch (id) {
            case this.SHOP.id:
                return this.SHOP;
            case this.RESTAURANT.id:
                return this.RESTAURANT;
            case this.SUPERMARKET.id:
                return this.SUPERMARKET;
            default:
                return {};
        }
    },
};

export const NON_WORKING_DAYS = [
    "Երկուշաբթի",
    "Երեքշաբթի",
    "Չորեքշաբթի",
    "Հինգշաբթի",
    "Ուրբաթ",
    "Շաբաթ",
    "Կիրակի",
];

export const PERCENTAGE_MEASUREMENTS = {
    PRACENT: {
        name: "_percent_",
        id: 0,
        symbol: "%",
    },
    FIXEDPRICE: {
        name: "_amd_",
        id: 1,
        symbol: "դր․",
    },
    measurments() {
        return [
            {
                name: this.PRACENT.name,
                value: this.PRACENT.id,
            },
            {
                name: this.FIXEDPRICE.name,
                value: this.FIXEDPRICE.id,
            },
        ];
    },
    measurementsById(id) {
        switch (id) {
            case this.FIXEDPRICE.id:
                return this.FIXEDPRICE;
            case this.PRACENT.id:
            default:
                return this.PRACENT;
        }
    },
};

export const DAY_IN_MILLISECONDS = 24 * 60 * 60 * 1000;
export const DAY_IN_MILLISECONDS_ND = 36 * 60 * 60 * 1000;

export const FUTURE_ORDERS_SHOW_TIME = 15;
export const PROMOTION_ORDERS_SHOW_TIME = 15;

export const TABS_NAMES = {
    ADMIN: "administrator",
    DEACTIVATED_USERS: "deactivatedUsers",
};

export const REPORT_TYPES = {
    TURNOVER: {
        name: "_turnover_",
        id: 0,
        tab: "",
    },
    SOLD_ITEMS: {
        name: "_sold_items_",
        id: 1,
        tab: "",
        startDate: "",
    },
    DISTRIBUTOR_REPORT: {
        name: "_distrybutor_report_",
        id: 2,
        tab: "finance",
        startDate: "",
    },
    INVOICE: {
        name: "_invoice_",
        id: 3,
        tab: "",
        startDate: "",
    },
    SUPPLIER: {
        name: "_collecting_time_",
        id: 4,
        tab: "",
        startDate: "",
    },
    DISTRIBUTOR_BALANCE: {
        name: "_distributor_balance_",
        id: 5,
        tab: "balance",
        startDate: moment().startOf("day"),
    },
    DISTRIBUTOR_TURNOVER: {
        name: "_distributor_turnover_",
        id: 6,
        tab: "turnover",
        startDate: moment().startOf("isoWeek"),
    },
    DISTRIBUTOR_TURNOVER_DETAILS: {
        name: "_distributor_turnover_details",
        id: 7,
        tab: "turnoverDetails",
        startDate: "",
    },
    TERMINAL: {
        name: "_terminal_",
        id: 8,
        tab: "terminal",
        startDate: moment().startOf("isoWeek"),
    },
    CASHBACK: {
        name: "_cashback_",
        id: 9,
        tab: "",
        startDate: "",
    },
    ORDERS_WITH_PROBLEMATIC_REPORTING: {
        name: "_orders_with_problematic_reporting_",
        id: 10,
        tab: "ordersWithProblematicReporting",
        startDate: moment().startOf("isoWeek"),
    },
    SUPPLIERS_AUTOMATIC_REPORT: {
        name: "_suppliers_automatic_report_",
        id: 11,
        tab: "suppliersAutomaticReport",
    },
    B2B_USERS_REPORT: {
        name: "_b2b_users_report_",
        id: 12,
        tab: "b2bUsersReport",
        startDate: moment().startOf("month"),
    },
    B2B_USERS_TOTAL_DEBT: {
        name: "_b2b_users_total_debt_",
        id: 13,
        tab: "b2bUsersTotalDebt",
        startDate: moment().startOf("month"),
    },
    MATERIAL_MEANS_REPORT: {
        name: "_material_means_report_",
        id: 14,
        tab: "materialMeansReport",
        startDate: moment().startOf("month"),
    },
    DISTRIBUTOR_SALARY_REPORT: {
        name: "_distributor_salary_report_",
        id: 15,
        tab: "distributorSalaryReport",
        startDate: moment().startOf("month"),
    },
    MANAGER_REPORT: {
        name: "_manager_report_",
        id: 16,
        tab: "managerReport",
        startDate: moment().startOf("month"),
    },
    SAVE_DEPOSIT: {
        name: "_save_deposit_",
        id: 17,
        tab: "distributorSaveReport",
        startDate: moment().startOf("month"),
    },
    DELIVERY_PRICE_REPORT: {
        name: "_delivery_price_report",
        id: 18,
        tab: "deliveryPriceReport",
        startDate: moment().startOf("day"),
    },
    HDM_PRINT_REPORT: {
        name: "_hdm_print_report_",
        id: 19,
        tab: "hdmPrintReport",
        startDate: moment().startOf("day"),
    },
    DEED_REPORT: {
        name: "_deed_report_",
        id: 20,
        tab: "deedReport",
        startDate: moment().startOf("day"),
    },
    SETTING_DELIVERY_SERVICE: {
        name: "_delivery_service_fees_",
        id: 21,
        tab: "deliveryServiceFee",
        startDate: moment().startOf("day"),
    },
    COURIER_MUTUAL_SETTLEMENTS: {
        name: "_couriers_mutual_settlements_",
        id: 22,
        tab: "couriersMutualSettlements",
        startDate: moment().startOf("day"),
    },
    types() {
        return [
            {
                name: this.TURNOVER.name,
                value: this.TURNOVER.id,
            },
            {
                name: this.SOLD_ITEMS.name,
                value: this.SOLD_ITEMS.id,
            },
            {
                name: this.DISTRIBUTOR_REPORT.name,
                value: this.DISTRIBUTOR_REPORT.id,
            },
            {
                name: this.INVOICE.name,
                value: this.INVOICE.id,
            },
            {
                name: this.SUPPLIER.name,
                value: this.SUPPLIER.id,
            },
            {
                name: this.DISTRIBUTOR_BALANCE.name,
                value: this.DISTRIBUTOR_BALANCE.id,
            },
            {
                name: this.DISTRIBUTOR_TURNOVER.name,
                value: this.DISTRIBUTOR_TURNOVER.id,
            },
            {
                name: this.TERMINAL.name,
                value: this.TERMINAL.id,
            },
            {
                name: this.CASHBACK.name,
                value: this.CASHBACK.id,
            },
            {
                name: this.SUPPLIERS_AUTOMATIC_REPORT.name,
                value: this.SUPPLIERS_AUTOMATIC_REPORT.id,
            },
            {
                name: this.B2B_USERS_REPORT.name,
                value: this.B2B_USERS_REPORT.id,
            },
            {
                name: this.B2B_USERS_TOTAL_DEBT.name,
                value: this.B2B_USERS_TOTAL_DEBT.id,
            },
            {
                name: this.MATERIAL_MEANS_REPORT.name,
                value: this.MATERIAL_MEANS_REPORT.id,
            },
            {
                name: this.DISTRIBUTOR_SALARY_REPORT.name,
                value: this.DISTRIBUTOR_SALARY_REPORT.id,
            },
            {
                name: this.MANAGER_REPORT.name,
                value: this.MANAGER_REPORT.id,
            },
            {
                name: this.SAVE_DEPOSIT.name,
                value: this.SAVE_DEPOSIT.id,
            },
            {
                name: this.DELIVERY_PRICE_REPORT.name,
                value: this.DELIVERY_PRICE_REPORT.id,
            },
            {
                name: this.HDM_PRINT_REPORT.name,
                value: this.HDM_PRINT_REPORT.id,
            },
            {
                name: this.DEED_REPORT.name,
                value: this.DEED_REPORT.id,
            },
            {
                name: this.SETTING_DELIVERY_SERVICE.name,
                value: this.SETTING_DELIVERY_SERVICE.id,
            },
            {
                name: this.COURIER_MUTUAL_SETTLEMENTS.name,
                value: this.COURIER_MUTUAL_SETTLEMENTS.id,
            },
            // {
            //     name: this.ORDERS_WITH_PROBLEMATIC_REPORTING.name,
            //     value: this.ORDERS_WITH_PROBLEMATIC_REPORTING.id
            // }
        ];
    },
    typeById(id) {
        switch (id) {
            case this.TURNOVER.id:
                return this.TURNOVER;
            case this.SOLD_ITEMS.id:
                return this.SOLD_ITEMS;
            case this.DISTRIBUTOR_REPORT.id:
                return this.DISTRIBUTOR_REPORT;
            case this.INVOICE.id:
                return this.INVOICE;
            case this.SUPPLIER.id:
                return this.SUPPLIER;
            case this.DISTRIBUTOR_BALANCE.id:
                return this.DISTRIBUTOR_BALANCE;
            case this.DISTRIBUTOR_TURNOVER.id:
                return this.DISTRIBUTOR_TURNOVER;
            case this.TERMINAL.id:
                return this.TERMINAL;
            case this.CASHBACK.id:
                return this.CASHBACK;
            case this.ORDERS_WITH_PROBLEMATIC_REPORTING.id:
                return this.ORDERS_WITH_PROBLEMATIC_REPORTING;
            case this.SUPPLIERS_AUTOMATIC_REPORT.id:
                return this.SUPPLIERS_AUTOMATIC_REPORT;
            default:
                return {};
        }
    },
};

export const REPORT_STATUSES = {
    DRAFT: {
        name: "_draft_",
        id: 0,
    },
    CHECKED: {
        name: "_checked_",
        id: 1,
    },
    statusById(id) {
        switch (id) {
            case this.CHECKED.id:
                return this.CHECKED;
            case this.DRAFT.id:
                return this.DRAFT;
            default:
                return {};
        }
    },
    statuses() {
        return [
            {
                name: this.CHECKED.name,
                value: this.CHECKED.id,
            },
            {
                name: this.DRAFT.name,
                value: this.DRAFT.id,
            },
        ];
    },
};

export const KEY_CODES = {
    minus: 45,
    dot: 46,
    zero: 48,
    nine: 57,
};

export const MAP_EVENT_KEY = 4;

export const INPUT_TYPE = {
    GRID: 0,
    LIST: 1,
};

export const OK_TELL_URL = "http://127.0.0.1:4059/callto?number=";

export const SUPPLIER_STATES = {
    DRAFT: {
        stateId: 0,
        name: "_draft_",
        className: "default",
    },
    READY_TO_SEND: {
        stateId: 5,
        name: "_ready_to_send_",
        className: "warning",
    },
    SENDED: {
        stateId: 6,
        name: "_sended_",
        className: "warning",
    },
    CONFIRMED: {
        stateId: 1,
        name: "_accepted_",
        className: "primary",
    },
    SENT_TO_PARTNER: {
        stateId: 3,
        name: "_sent_to_partner_",
        className: "warning",
    },
    REJECTED: {
        stateId: 2,
        name: "_rejected_",
        className: "danger",
    },
    READY_TO_DELIVERY: {
        stateId: 4,
        name: "_ready_to_delivery_",
        className: "success",
    },
    stateById(id) {
        switch (id) {
            case SUPPLIER_STATES.CONFIRMED.stateId:
                return SUPPLIER_STATES.CONFIRMED;
            case SUPPLIER_STATES.REJECTED.stateId:
                return SUPPLIER_STATES.REJECTED;
            case SUPPLIER_STATES.SENT_TO_PARTNER.stateId:
                return SUPPLIER_STATES.SENT_TO_PARTNER;
            case SUPPLIER_STATES.READY_TO_DELIVERY.stateId:
                return SUPPLIER_STATES.READY_TO_DELIVERY;
            case SUPPLIER_STATES.READY_TO_SEND.stateId:
                return SUPPLIER_STATES.READY_TO_SEND;
            case SUPPLIER_STATES.SENDED.stateId:
                return SUPPLIER_STATES.SENDED;
            default:
                return SUPPLIER_STATES.DRAFT;
        }
    },
};

export const PRODUCT_STATUSES = {
    DRAFT: 1,
    ON_DISCUSS: 2,
    CONFIRMED: 3,
};
export const PRODUCT_MODES = {
    VOUCHER: 2,
};

export const SALARY_TYPES_ENUM = {
    PRIMARY: 1,
    SECONDARY: 2,
    NONE: 3,
};

export const SALARY_TYPES = {
    SALARY: {
        name: "_salary_",
        id: 0,
    },
    BONUS: {
        name: "_bonus_",
        id: 1,
    },
    types() {
        return [
            {
                name: this.SALARY.name,
                value: this.SALARY.id,
            },
            {
                name: this.BONUS.name,
                value: this.BONUS.id,
            },
        ];
    },
    typeById(id) {
        switch (id) {
            case this.SALARY.id:
                return this.SALARY;
            case this.BONUS.id:
                return this.BONUS;
            default:
                return {};
        }
    },
};

export const MEASUREMENT_TYPE = {
    PERCENT: 0,
    FIXED: 1,
};
export const SALARY_FIELDS = {
    TARIFF: {
        id: 0,
        name: "tariff",
    },
    UNIQUE: {
        id: 1,
        name: "uniqueOrderRanges",
    },
    SECONDARY: {
        id: 2,
        name: "secondaryOrderRanges",
    },
    BONUS: {
        id: 3,
        name: "bonus",
    },
    PAYMENT: {
        id: 4,
        name: "payment",
    },
    HISTORY: {
        id: 5,
        name: "history",
    },
};

export const DEFAULT_DELIVERY_PRICE = 700;

export const TRANSACTION_TYPES = {
    ORDER: 1,
    FINANCE: 2,
    PAYMENT_TERMINAL: 3,
    AUTO_INCREASE: 4,
    SALARY_AUTO_INCREASE: 5,
    PAY_SALARY: 6,
    AUTO_INCREASE_SAVE_DEPOSIT: 7,
    PAY_SAVE_DEPOSIT: 8,
};

export const TRANSACTION_DATA = {
    INPUT: "input",
    OUTPUT: "output",
};

export const COMPARATIONS = {
    GREATER: ">",
    EQUAL_GREATER: ">=",
    LESS: "<",
    EQUAL_LESS: "<=",
    EQUAL: "=",
    ADD: "+",
};

export const TRANSPORT_ICONS = {
    car: require("../assets/car-alt-solid.svg"),
    bike: require("../assets/biking-solid.svg"),
    motobike: require("../assets/motorcycle-solid.svg"),
    scooter: require("../assets/electro-scooter.svg"),
};

export const LOADING = {
    size: 20,
    color: "#000000",
    sizeInButton: 15,
    colorInButton: "#ffffff",
};

export const COLORS = {
    GREEN: "#5cb85c",
    GREY: "#bfbfbf",
    RED: "#c8312c",
    BLACK: "#000000",
    BLUE: "#296190",
    ORANGE: "#ec9720",
    YELLOW: "#ffdf00",
};

export const SELECT = {
    inputInMap: 400,
    inputInRow: 150,
};

export const DISTRIBUTOR_COOPERATION_TYPES = {
    partner: {
        title: "_partner_",
        isDefault: true,
        id: 1,
    },
    employee: {
        title: "_employee_loan_",
        isDefault: false,
        id: 2,
    },
};

export const DISTRIBUTOR_TERMINAL_TYPES = {
    standard: {
        title: "_standard_",
        isDefault: true,
        id: 1,
    },
    soft: {
        title: "_soft_",
        isDefault: false,
        id: 2,
    },
};

export const COMPANY = {
    C1: {
        id: "C1",
        name: "«ՓՐԱՅՄ ՖՈՒԴ» ՍՊԸ",
        alias: "Foodplace",
        tin: "04440667",
    },
    C2: {
        id: "C2",
        name: "«ԴԱՐՔ ՍԹՈՐ» ՍՊԸ",
        alias: "Darkstore",
        tin: "01308804",
    },
    C3: {
        id: "C3",
        name: "«ՖԱՍՏ ԴԵԼԻՎԸՐԻ» ՍՊԸ",
        alias: "Fastdelivery",
        tin: "",
    },
    companies(key = "name", value = "id") {
        return [
            {
                [key]: this.C1.name,
                value: this.C1[value],
            },
            {
                [key]: this.C2.name,
                value: this.C2[value],
            },
        ];
    },
    getCompanyByTin(tin) {
        const companies = [this.C1, this.C2];
        return companies.find((item) => item.tin == tin);
    },
};

export const NOTIFICATION_TYPES = {
    EMAIL: {
        id: 0,
        name: "Email",
    },
    SMS: {
        id: 1,
        name: "SMS",
    },
    CALL: {
        id: 2,
        name: "Call",
    },
    PUSH_NOTIFICATION: {
        id: 3,
        name: "Push Notification",
    },
    types() {
        return [
            {
                name: this.EMAIL.name,
                value: this.EMAIL.id,
            },
            {
                name: this.SMS.name,
                value: this.SMS.id,
            },
            {
                name: this.CALL.name,
                value: this.CALL.id,
            },
            {
                name: this.PUSH_NOTIFICATION.name,
                value: this.PUSH_NOTIFICATION.id,
            },
        ];
    },
};

export const DEED_STATUSES = {
    SENT: {
        name: "_sent_",
        id: 1,
        className: "default",
    },
    ACCEPTED: {
        name: "_accepted_",
        id: 2,
        className: "success",
    },
    DECLINED: {
        name: "_declined_",
        id: 3,
        className: "danger",
    },
    statusById(id) {
        switch (id) {
            case this.SENT.id:
                return this.SENT;
            case this.ACCEPTED.id:
                return this.ACCEPTED;
            case this.DECLINED.id:
                return this.DECLINED;
            default:
                return {};
        }
    },
    statuses() {
        return [
            {
                name: this.SENT.name,
                value: this.SENT.id,
            },
            {
                name: this.ACCEPTED.name,
                value: this.ACCEPTED.id,
            },
            {
                name: this.DECLINED.name,
                value: this.DECLINED.id,
            },
        ];
    },
};

export const DISTRIBUTOR_DEED_STATUSES = {
    PENDING: 1,
    ACCEPTED: 2,
    REJECTED: 3,
};

export const deletedTariffColumns = [
    {
        type: "text",
        title: "_name_",
        label: "_tariff_name_",
        name: "name",
        key: "name",
        isNested: false,
        isKey: true,
        required: true,
        validations: {},
        validationErrors: "",
        showInTable: true,
        dataSort: true,
    },
    {
        type: "distributorType",
        title: "_type_",
        label: "_choose_picture_",
        name: "distributorType",
        key: "distributorType",
        isNested: false,
        isKey: false,
        required: true,
        validations: {},
        validationErrors: "",
        showInTable: true,
        dataSort: true,
    },
    {
        type: "number",
        title: "_fixed_salary_",
        label: "_fixed_salary_",
        name: "baseSalary",
        key: "baseSalary",
        isNested: false,
        isKey: false,
        required: true,
        validations: {
            matchRegexp: /^[0-9]\d*$/,
        },
        validationErrors: {
            matchRegexp: "_min_number_error_",
        },
        showInTable: true,
        dataSort: true,
    },
    {
        type: "number",
        title: "_min_orders_count_",
        label: "_min_daily_orders_count_",
        name: "minOrdersCount",
        key: "minOrdersCount",
        isNested: false,
        isKey: false,
        required: true,
        validations: {
            matchRegexp: /^[0-9]\d*$/,
        },
        validationErrors: {
            matchRegexp: "_min_number_error_",
        },
        showInTable: true,
        dataSort: true,
    },
    {
        type: "number",
        title: "_min_working_days_",
        label: "_working_days_count_",
        name: "minWorkingDays",
        key: "minWorkingDays",
        isNested: false,
        isKey: false,
        required: true,
        validations: {
            matchRegexp: /^[1-9]\d*$/,
        },
        validationErrors: {
            matchRegexp: "_min_number_error_",
        },
        showInTable: true,
        dataSort: true,
    },
    {
        type: "switch",
        title: "_status_",
        key: "status",
        isKey: false,
        showInTable: true,
        dataSort: true,

    },

];

export const dateTimeFormats = {
    date: "DD/MM/YYYY",
    time: "HH:mm",
    dateTime: "DD/MM/YYYY HH:mm",
};

export const REPORT_ROUTES = {
    [REPORT_TYPES.DISTRIBUTOR_BALANCE.id]: "/orders/balance",
    [REPORT_TYPES.DISTRIBUTOR_TURNOVER.id]: "/orders/turnover",
    [REPORT_TYPES.TERMINAL.id]: "/orders/terminal",
    [REPORT_TYPES.SUPPLIERS_AUTOMATIC_REPORT.id]:
        "/orders/suppliersAutomaticReport",
    [REPORT_TYPES.B2B_USERS_REPORT.id]: "/orders/b2bUsersReport",
    [REPORT_TYPES.B2B_USERS_TOTAL_DEBT.id]: "/orders/b2bUsersTotalDebt",
    [REPORT_TYPES.MATERIAL_MEANS_REPORT.id]: "/orders/materialMeansReport",
    [REPORT_TYPES.DISTRIBUTOR_SALARY_REPORT.id]:
        "/orders/distributorSalaryReport",
    [REPORT_TYPES.MANAGER_REPORT.id]: "/orders/managerReport",
    [REPORT_TYPES.SAVE_DEPOSIT.id]: "/orders/distributorSaveReport",
    [REPORT_TYPES.DELIVERY_PRICE_REPORT.id]: "/orders/deliveryPriceReport",
    [REPORT_TYPES.HDM_PRINT_REPORT.id]: "/orders/hdmPrintReport",
    [REPORT_TYPES.DEED_REPORT.id]: "/orders/deedReport",
    [REPORT_TYPES.SETTING_DELIVERY_SERVICE.id]: "/orders/deliveryService",
    [REPORT_TYPES.COURIER_MUTUAL_SETTLEMENTS.id]: "/orders/courier/settlement",
};

// Reason-selection gate for the delivery amount field (OMSNEW-1148).
// Backend contract: deliveryPriceChangeReason = { reason: <1-7>, comment: <string> }.
// Only OTHER (6) requires the free-text explanation (max 500 chars).
export const DELIVERY_PRICE_CHANGE_REASONS = [
    { value: 1, label: "Ուշացում" },
    { value: 2, label: "Առաքման խնդիր" },
    { value: 3, label: "ԶԿ խնդիր" },
    { value: 4, label: "Մատակարարի խնդիր" },
    { value: 5, label: "Կոնտենտ" },
    { value: 7, label: "Հասցեի փոփոխում" },
    { value: 6, label: "Այլ" },
];
export const DELIVERY_PRICE_OTHER_REASON = 6;
export const DELIVERY_PRICE_OTHER_MAX_LENGTH = 500;
export const DELIVERY_PRICE_REASON_LABEL = "Առաքման գումարի փոփոխման պատճառ";
